<template>
  <div id="detectAudit">
    <div class="info" v-if="!detectInfo">
      当前无待审核记录
    </div>
    <div class="panel" v-if="detectInfo">
      <div class="gallery second-row">
        <div class="pic-container grid-item second-row third" :class="{ 'selected' : selectedImg === 4}" id="image4" v-if="detectInfo.image_jszdyy !== 'none'">
          <div class="caption">行驶本+合格标志</div>
          <img class="pic" v-if="detectInfo.image_jszdyy" :src="detectInfo.image_jszdyy + '!max-w-800'" preview="4"
               preview-text="行驶本+合格标志" title="行驶本+合格标志" @click="setCurrentImage(4)">
          <img v-else src="../assets/no-img.png" title="行驶本+合格标志(未上传)">
        </div>

        <div class="pic-container grid-item second-row"
             :class="detectInfo.image_zhjcd ? (detectInfo.image_zhjcd === 'none' ? 'one' : 'third') : 'none'"
             v-if="detectInfo.image_zhjcd !== 'none'"
             id="image5">
          <div class="caption">综合检查单</div>
          <img class="pic" v-if="detectInfo.image_zhjcd" :src="detectInfo.image_zhjcd + '!max-w-800'" preview="5"
               preview-text="综合检查单" title="综合检查单" @click="setCurrentImage(5)">
          <img v-else src="../assets/no-img.png" title="综合检查单(未上传)">
        </div>

        <div class="pic-container grid-item second-row third"
             :class="{ 'selected' : selectedImg === 6}"
             id="image6" v-if="detectInfo.image_aqjcd !== 'none'">
          <div class="caption">安全检查单</div>
          <img class="pic" v-if="detectInfo.image_aqjcd" :src="detectInfo.image_aqjcd + '!max-w-800'" preview="6"
               preview-text="安全检查单" title="安全检查单" @click="setCurrentImage(6)">
          <img v-else src="../assets/no-img.png" title="安全检查单(未上传)">
        </div>
      </div>
      <div class="gallery first-row">
        <div class="pic-container grid-item first-row" :class="{'selected' : selectedImg === 1}" >
          <div class="caption">制动检验工位</div>
          <img class="pic" v-if="detectInfo.image_imageUrl1" :src="detectInfo.image_imageUrl1 + '!max-w-800'"
               preview="1" preview-text="制动检验工位" title="制动检验工位" id="image0" @click="setCurrentImage(1)">
          <img class="none" v-else src="../assets/no-img.png" title="制动检验工位(未上传)">
        </div>

        <div class="pic-container grid-item first-row" :class="{'selected' : selectedImg === 2}" id="image2">
          <div class="caption">灯光检验工位</div>
          <img class="pic" v-if="detectInfo.image_imageUrl2" :src="detectInfo.image_imageUrl2 + '!max-w-800'"
               preview="2" preview-text="灯光检验工位" title="灯光检验工位" @click="setCurrentImage(2)">
          <img class="none" v-else src="../assets/no-img.png" title="灯光检验工位(未上传)">
        </div>

        <div class="pic-container grid-item first-row" :class="{ 'selected' : selectedImg === 3}" id="image3">
          <div class="caption">动力性检验工位</div>
          <img class="pic" v-if="detectInfo.image_imageUrl3" :src="detectInfo.image_imageUrl3 + '!max-w-800'"
               preview="3" preview-text="动力性检验工位" title="动力性检验工位" @click="setCurrentImage(3)">
          <img class="none" v-else src="../assets/no-img.png" title="动力性检验工位(未上传)">
        </div>
      </div>
    </div>
    <div class="report-info" v-if="detectInfo">
      <div class="entry">
        <div class="label">车牌：</div>
        <div class="content">
          <div class='plate' :class="'plate-color-' + detectInfo.plateColorCode">
            <div class="vehicle-no" v-if="detectInfo.plateColorCode === '93'">
              <span class="left-part">{{ detectInfo.vehicleNo.substring(0, 2) }}</span>
              <span class="part">{{ detectInfo.vehicleNo.substring(2) }}</span>
            </div>
            <div class="vehicle-no" v-else>
              {{detectInfo.vehicleNo}}
            </div>
          </div>
        </div>
      </div>
      <div class="entry">
        <div class="label">注册日期：</div>
        <div class="content">{{detectInfo.registDate}}</div>
      </div>
      <div class="entry">
        <div class="label">检验城市：</div>
        <div class="content">{{detectInfo.cityName}}</div>
      </div>
      <div class="entry">
        <div class="label">机构名称：</div>
        <div class="content">{{detectInfo.dsName}}</div>
      </div>
      <div class="entry">
        <div class="label">车辆技术等级：</div>
        <div class="content">{{detectInfo.evaluateresult_vehicletechrank}}</div>
      </div>
      <div class="entry">
        <div class="label">车辆类型：</div>
        <div class="content">{{detectInfo.vehicleType}}</div>
      </div>
      <div class="entry">
        <div class="label">使用性质：</div>
        <div class="content">{{detectInfo.vehicleNature}}</div>
      </div>
      <div class="entry">
        <div class="label">检测日期：</div>
        <div class="content">{{detectInfo.detectDate}}</div>
      </div>
      <div class="entry">
        <div class="label">上次上传日期：</div>
        <div class="content">{{detectInfo.lastUploadTime}}</div>
      </div>
      <div class="entry">
        <div class="label">上次审核日期：</div>
        <div class="content">{{detectInfo.lastAuditTime}}</div>
      </div>
      <div class="entry">
        <div class="label">状态：</div>
        <div class="content">{{detectInfo.status === 1 ? "检测信息已上报" : (detectInfo.status === 2 ? "审核中" : (detectInfo.status === 3 ? "审核通过" : "审核拒绝"))}}</div>
      </div>
      <div class="operations">
        <el-button type="success" plain @click="approve" icon="el-icon-check">通过</el-button>
        <el-button type="danger" plain @click="rejectDialogVisible = true" icon="el-icon-close">拒绝</el-button>
      </div>
      <div class="tips">
        说明：审核操作后，自动进入下一条
      </div>
    </div>
    <el-dialog title="拒绝原因" width="600" :visible.sync="rejectDialogVisible">
      <el-form :model="form">
        <el-form-item label="照片缺失：">
          <el-checkbox-group v-model="form.pics1">
            <el-checkbox v-model="form.pics1" value="行驶本" label="行驶本"></el-checkbox>
            <el-checkbox v-model="form.pics1" value="合格证" label="合格证"></el-checkbox>
            <el-checkbox v-model="form.pics1" value="综检报告单" label="综检报告单"></el-checkbox>
            <el-checkbox v-model="form.pics1" value="安检报告单" label="安检报告单"></el-checkbox>
            <el-checkbox v-model="form.pics1" value="灯光工位照" label="灯光检验工位"></el-checkbox>
            <el-checkbox v-model="form.pics1" value="制动工位照" label="制动工位照"></el-checkbox>
            <el-checkbox v-model="form.pics1" value="动力性工位照" label="动力性工位照"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="照片模糊：">
          <el-checkbox-group v-model="form.pics2">
            <el-checkbox v-model="form.pics2" value="行驶本" label="行驶本"></el-checkbox>
            <el-checkbox v-model="form.pics2" value="合格证" label="合格证"></el-checkbox>
            <el-checkbox v-model="form.pics2" value="综检报告单" label="综检报告单"></el-checkbox>
            <el-checkbox v-model="form.pics2" value="安检报告单" label="安检报告单"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="照片有误：">
          <el-checkbox-group v-model="form.pics3">
            <el-checkbox v-model="form.pics3" value="综检报告单上传错误" label="综检报告单上传错误"></el-checkbox>
            <el-checkbox v-model="form.pics3" value="综检报告单未盖章" label="综检报告单未盖章"></el-checkbox>
            <el-checkbox v-model="form.pics3" value="合格证请拍摄有日期的一面" label="合格证请拍摄有日期的一面"></el-checkbox>
            <el-checkbox v-model="form.pics3" value="车牌颜色有误" label="车牌颜色有误"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item prop="textarea" label="其它原因：">
          <el-input type="textarea" v-model="form.otherReason"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="reject">确认</el-button>
          <el-button @click="rejectDialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog width="600" :visible.sync="alertDialogVisible">
      <div style="font-size: 24px;font-weight:bold;">当前有{{todoCount}}条检车信息需要审核&emsp;&emsp;
        <el-button type="primary" @click="doIt">立即去处理</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios'
  import qs from 'qs';
  import {verifyReport} from '../modules/axios/request'
  import {fetchForAudit} from '../modules/services/basic-service'
  import _ from 'lodash'

  export default {
    data() {
      return {
        detectInfo: null,
        currentImg: null,
        selectedImg: 1,
        selectedCaption: '',
        rejectDialogVisible: false,
        alertDialogVisible: false,
        todoCount: 0,
        form: {
          reason: [],
          pics1: [],
          pics2: [],
          pics3: [],
          otherReason: ''
        }
      }
    },
    components: {
    },
    computed: {
      scale () {
        if (document.documentElement.clientWidth < 800 || document.documentElement.clientHeight < 600) {
          return 6
        } else if (document.documentElement.clientWidth < 1024 || document.documentElement.clientHeight < 800) {
          return 4
        } else {
          return 2
        }
      },
      gridClass () {
        if (this.detectInfo.image_aqjcd === 'none') {
          return 'one'
        } else {
          return 'third'
        }
      }
    },
    methods: {
      doIt () {
        this.alertDialogVisible = false
        this.fetchOne()
      },
      fetchOne() {
        const self = this;
        this.selectedCaption = '';
        this.selectedImg = null;
        this.currentImg = null;
        self.form = {
          reason: [],
          pics1: [],
          pics2: [],
          pics3: [],
          otherReason: ''
        };
        fetchForAudit().then(({body}) => {
          if (body) {
            self.detectInfo = body;
            if (self.detectInfo.image_jszdyy.indexOf('none') > 0) {
              self.detectInfo.image_jszdyy = 'none';
            }
            if (self.detectInfo.image_aqjcd.indexOf('none') > 0) {
              self.detectInfo.image_aqjcd = 'none';
            }
            if (self.detectInfo.image_zhjcd.indexOf('none') > 0) {
              self.detectInfo.image_zhjcd = 'none'
            }
          } else {
            self.detectInfo = null
          }
        })
      },
      approve () {
        this.doVerify(this.detectInfo.id, true);
      },
      reject () {
        this.rejectDialogVisible = false;
        let reason = '';
        if (this.form.pics1.length > 0) {
          reason = reason + _.join(this.form.pics1, '、') + ' 照片缺失；';
        }
        if (this.form.pics2.length > 0) {
          reason = reason + _.join(this.form.pics2, '、') + ' 照片模糊；';
        }
        if (this.form.pics3.length > 0) {
          reason = reason + _.join(this.form.pics3, '；') + '；';
        }
        reason = reason + (this.form.otherReason ? this.form.otherReason : '');
        this.doVerify(this.detectInfo.id, false, reason);
      },
      doVerify(id, result, reason) {
        const self = this;
        axios.post(verifyReport.doVerify, qs.stringify({
          id: id,
          result: result,
          reason: reason
        }), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then((body) => {
            if (body && body.data && body.data.result) {
              self.detectInfo = null;
              self.fetchOne();
            }
          })
      },
      list () {
        const self = this;
        axios.get(verifyReport.list + "?status=2&page=1&pageSize=1", {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
          .then((body) => {
            if (body && body.data && body.data.total > 0) {
              self.todoCount = body.data.total;
              self.alertDialogVisible = true;
            }
          })
      }
    },
    mounted() {
      this.fetchOne();
      const self = this;
      setInterval(function () {
        if (!self.detectInfo) {
          self.list()
        }
      }, 60000)
    },

  }
</script>

<style lang='stylus' scoped>
  #detectAudit {
    .info {
      font-size: 48px;
      font-weight: bold;
      width: 100%;
      text-align center;
      margin-top: 50px;
      color: #ccc;
    }
    .panel {
      width: calc(100vw - 360px);
      height: 100vh;
      overflow-y hidden
    }
    .pic-caption {
      position absolute;
      padding: 5px 10px;
      bottom: 0
      text-align center
      font-size: 28px;
      font-weight: bold;
      line-height: 32px;
      background: #000;
      color: #fff;
      z-index: 9000
      opacity 0.6;
    }
    .pic-container {
      cursor: pointer
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border: 4px solid #ccc;
      margin-right: 5px;
      &:last-child {
        margin-right: 0;
      }
      &.first-row {
        width: calc(100vw / 3 - 132px);
        height: calc(200vw / 9 - 90px);
      }
      &.second-row {
        &.one {
          height: calc(100vh - 200vw / 9 + 69px);
          img {
            max-width: calc(100vw - 380px);
            max-height: calc(100vh - 200vw / 9 + 69px);
          }
        }
        &.third {
          img {
            max-width: calc(100vw / 3 - 132px);
            max-height: calc(100vh - 200vw / 9 + 69px);
          }
        }
        &.none {
          width: calc(100vw / 3 - 132px);
          height: calc(100vh - 200vw / 9 + 69px);
        }
      }
      &.first-row {
        margin-top: 5px;
      }
      &.first-row img {
        max-width: calc(100vw / 3 - 135px);
        max-height: calc(200vw / 9 - 90px);
      }
      .caption {
        position: absolute;
        bottom: 0;
        width: 100%;
        text-align: center;
        color: #fff;
        background: #000;
        padding: 5px 0;
        opacity 0.6;
        font-size: 16px;
      }
    }
    .gallery {
      display flex
      flex-wrap wrap-reverse;
      align-items center
      .pic-container:last-child {
        margin-right: 0
      }
    }
    .report-info {
      position: absolute;
      top: 0;
      right: 0;
      background: #eee;
      width: 360px;
      overflow-y: scroll;
      height: 100vh;
      .entry {
        display: flex;
        justify-content: flex-start;
        align-items center;
        line-height: 24px;
        padding: 5px 10px;
        &:nth-child(odd) {
          background-color white
        }
        .label {
          color: #999;
          font-weight: bold;
          width: 120px;
        }
        .content {
          text-align: left;
          width: 220px;
        }
      }
      .operations {
        border-top 1px solid #ccc;
        padding-top: 20px;
        display: flex;
        justify-content center
        margin: 20px 0;
        line-height: 50px
        button {
          font-size: 20px;
          width: 160px;
          margin: 0 20px;
          font-weight: bold;
        }
      }
      .tips {
        border-top: 1px solid #ccc;
        color: #ccc;
        padding-top: 10px;
        text-align center
        padding-bottom: 30px;
      }
    }
    .plate {
      text-align: center;
      line-height: 24px;
      width: 120px;
      border-radius: 5px;
    }
    .vehicle-no {
      border: 2px solid white;
      font-weight: bold;
      border-radius: 3px;
      padding: 2px;
      font-size: 14px;
    }
    .plate-color-1 {
      border: 1px solid #1B3288;
    }
    .plate-color-2 {
      border: 1px solid #fc0;
    }
    .plate-color-93, .plate-color-94 {
      border: 1px solid #36D753;
    }
    .plate-color-1 .vehicle-no {
      border-color: white;
      background: #1B3288;
      color: white;
    }
    .plate-color-2 .vehicle-no {
      border-color: black;
      background: rgb(255, 190, 0);
      color: black;
    }
    .plate-color-93 .vehicle-no {
      border-color: black;
      background: rgb(255, 190, 0);
      color: black;
      padding-right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .plate-color-93 .vehicle-no .part {
      background: rgb(54, 215, 83);
      margin-left: 3px;
      padding: 0 10px 0 5px;
    }
    .plate-color-94 .vehicle-no {
      border-color: black;
      background: linear-gradient(white, #36D753);
      background: -webkit-linear-gradient(white, #36D753);
      color: black;
    }
  }
  .reject-pic-list {
    padding-left: 30px;
    margin-top: 10px;
    border: 1px solid #eee;
    padding-top: 10px;
    padding-bottom: 5px;
  }
</style>
<style lang="stylus">
  #detectAudit {
    .magnifier-box .edit-wrap {
      top 5px;
      right: unset;
    }
  }
</style>